module.exports = __webpack_public_path__ + "static/media/seigneur1.21d54328.jpg";